import { useMemo } from "react";

import { useAdoptedBudgetMix } from "@features/mmm/hooks/use-adopted-budget-mix";
import { useFeatureFlags } from "@hooks/http";

import { usePerformanceTrackingData } from "./performance-tracking-provider";

export const usePerformanceTrackingLiveForecastData = () => {
  const { liveForecastData, loading } = usePerformanceTrackingData();
  const { hasFeatureFlag } = useFeatureFlags();
  const enableMMMLiveForecasting = hasFeatureFlag("enableMMMLiveForecasting");

  const { adoptedBudgetMix } = useAdoptedBudgetMix();

  const trackingliveForecastData = useMemo(() => {
    const liveForecast =
      liveForecastData?.me?.mmm?.performanceTracking?.liveForecast.data ?? [];

    return liveForecast;
  }, [liveForecastData]);

  const isLoading =
    loading || trackingliveForecastData.length === 0 || !adoptedBudgetMix;

  return {
    loading: isLoading,
    trackingliveForecastData,
    enableMMMLiveForecasting,
  };
};
